import {putAll, takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {call, put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {t} from 'app/translations';
import {showBeError} from 'utils/show-be-error';

import {SearchOrganizationsAction, userDetailAction} from '../action';

function* execute({payload}: SearchOrganizationsAction): SagaIterator {
    const response = yield* call(Api.searchOrganizations, {text: payload});

    if (response.isSuccess) {
        yield* put(userDetailAction.setOrganizationOptions(response.data));
    } else {
        yield putAll(showBeError(response, t('userDetail')('organizationsLoading')));
    }
}

export function* searchOrganizationsSaga(): SagaIterator {
    yield takeLatestF('userDetail/SEARCH_ORGANIZATIONS', execute);
}
